@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-customer-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [customer]="_context.formContext.item"
                (customerUpdated)="onCustomerUpdated($event)"
                (canceled)="onCanceled($event)"></app-customer-form>
        </mat-tab>
        @if (!!_context.formContext.item.id) {
            <mat-tab label="Alias des Articles">
                <app-customer-article-alias-form
                    [context]="_context.formContext"
                    (customerUpdated)="onCustomerUpdated($event)"
                    (canceled)="onCanceled($event)"></app-customer-article-alias-form>
            </mat-tab>
        }
    </mat-tab-group>
}
